import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
type FbqFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  loaded?: boolean;
  push?: (...args: unknown[]) => void;
  queue?: unknown[][];
  version?: string;
};
declare global {
  interface Window {
    _fbq?: FbqFunction;
    fbq?: FbqFunction;
  }
}
const META_PIXEL_ID = '1751466005855111';
const META_PIXEL_SCRIPT_ID = 'meta-pixel-base-code';
const META_PIXEL_INITIALIZED_ATTRIBUTE = 'data-meta-pixel-initialized';
export function MetaPixel() {
  const location = useLocation();
  useEffect(() => {
    const existingPixel = window.fbq;
    const fbq = existingPixel ?? createFbqStub();
    window.fbq = fbq;
    window._fbq = fbq;
    const script = document.getElementById(META_PIXEL_SCRIPT_ID) as HTMLScriptElement | null;
    if (!script) {
      const pixelScript = document.createElement('script');
      pixelScript.id = META_PIXEL_SCRIPT_ID;
      pixelScript.async = true;
      pixelScript.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(pixelScript);
    }
    if (!document.documentElement.hasAttribute(META_PIXEL_INITIALIZED_ATTRIBUTE)) {
      fbq('init', META_PIXEL_ID);
      document.documentElement.setAttribute(META_PIXEL_INITIALIZED_ATTRIBUTE, 'true');
    }
  }, []);
  useEffect(() => {
    window.fbq?.('track', 'PageView');
  }, [location.pathname, location.search]);
  return null;
}
function createFbqStub(): FbqFunction {
  const fbq = ((...args: unknown[]) => {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
      return;
    }
    fbq.queue?.push(args);
  }) as FbqFunction;
  fbq.queue = [];
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.push = (...args: unknown[]) => fbq(...args);
  return fbq;
}